// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2EAcp","load4":"Spinner_load4__2k-up"};